import { Dialog } from "primereact/dialog";
import { FC } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch, RootState, useAppSelector } from "../redux/AppStore";
import { UpdateAddressfromAuto, UpdateContactAddressActionThunk, UpdateTrackingAddressActionThunk, verifyAddressThunk } from "../redux/slice/UpdateTrackingAddressSlice";
import CustomerEmailComponent from "./form/CustomerEmailComponent";
import ShipmentCountryComponent from "./form/ShipmentCountryComponent";
import ShipmentPostcodeComponent from "./form/ShipmentPostcodeComponent";
import ShipmentCityComponent from "./form/ShipmentCityComponent";
import ShipmentAddress2Component from "./form/ShipmentAddress2Component";
import ShipmentAddress1Component from "./form/ShipmentAddress1Component";
import CustomerNameComponent from "./form/CustomerNameComponent";
import CustomerPhoneComponent from "./form/CustomerPhoneComponent";
import ShipmentStateComponents from "./form/ShipmentStateComponent";
import Autocomplete from 'react-google-autocomplete'
import MapComponent from "./Map/MapComponents";
import { browserTimeZone } from "./trackingSettings";
type DialogProps = {
  visible: boolean;
  setVisible: (show: boolean) => void;
}

const VerifyAddressComponent: FC<DialogProps> = ({ visible, setVisible }) => {
  const Address = useAppSelector((state: RootState) => state.updateAddress.userData);
  const dispatch = useDispatch<AppDispatch>();
  const trackingNumber = useAppSelector((state: RootState) => state.tracking.trackingNum);
  const newUserData = useAppSelector((state: RootState) => state.updateAddress.newuserData);
  const verifyinfo = useAppSelector((state: RootState) => state.updateAddress.verifydata);
  const countrylist = useAppSelector((state: RootState) => state.updateAddress.countryInfo);
  const isloading = useAppSelector((state: RootState) => state.updateAddress.isLoading);
  const shipmentStatus = useAppSelector((state: RootState) => state.updateAddress.status);
  const contactAddress = () => {
    dispatch(
      UpdateContactAddressActionThunk({
        contactAddressData: {
          shipment_customer_phone: newUserData.shipment_customer_phone,
          shipment_customer_email: newUserData.shipment_customer_email,
          shipment_customer_name: newUserData.shipment_customer_name,
        },
        oldContactInfo: {
          contact_name: Address.shipment_customer_name,
          contact_number: Address.shipment_customer_phone,
          contact_email: Address.shipment_customer_email,
        },
        shipment_id: Address.shipment_id,
        load_identity: String(trackingNumber),
        endPointUrl: "/updateContactAddress",
        timezone_name: browserTimeZone(),
      }),
    );
    if (!isloading && shipmentStatus === true) {
      setVisible(false);
    }

  }
  const ValidateAddress = () =>{
    if(newUserData.shipment_address1 == ''){
      alert('Please Provide Address line 1 !')
      return false;
    }else if (newUserData.shipment_address2 == ''){
      alert('Please Provide Address line 2 !')
      return false;
    }else if (newUserData.shipment_customer_city == ''){
      alert('Please Provide city !')
      return false;
    }else if (newUserData.shipment_state == ''){
      alert('Please Provide state!')
      return false;
    }else if (newUserData.shipment_postcode == ''){
      alert('Please Provide postcode !')
      return false;
    }
    return( true );
  }
  var newLocations:any = {};

  const UserTrackingAddress = () => {
    var fromValidate =  ValidateAddress();
    if(!fromValidate){
      return false;
  }
  if(Address.shipment_postcode != newUserData.shipment_postcode ){
    newLocations = {
    'lat': Number(newUserData.shipment_latitude),
    'lng': Number(newUserData.shipment_longitude)
    }
}
    dispatch(
      UpdateTrackingAddressActionThunk({
        addressData: {
          address_line1: newUserData.shipment_address1,
          address_line2: newUserData.shipment_address2,
          city: newUserData.shipment_customer_city,
          state: newUserData.shipment_state,
          country_list: newUserData.shipment_country_code,
          postcode: newUserData.shipment_postcode,
        },

        oldaddressData: {
          status: true,
          message: "Match with postcode!",
          data: {
            shipment_address1: String(Address.shipment_address1),
            shipment_address2: String(Address.shipment_address2),
            shipment_customer_city: String(Address.shipment_customer_city),
            shipment_customer_country: String(Address.shipment_customer_country),
            shipment_latitude: String(Address.shipment_latitude),
            shipment_longitude: String(Address.shipment_longitude),
            shipment_postcode: String(Address.shipment_postcode),
            shipment_state: String(Address.shipment_state),
            shipment_country_code: String(Address.shipment_customer_country),
            shipment_id: Address.shipment_id,
            tracking_code: String(Address.tracking_code),
            address_id: Address.address_id,
            load_identity: String(Address.load_identity),
            shipment_customer_phone: String(Address.shipment_customer_phone),
            shipment_customer_name: String(Address.shipment_customer_name),
            shipment_customer_email: String(Address.shipment_customer_email),
          },
          country_list: countrylist,
          verify_info: Array(verifyinfo),
        },
        verifiedid: Number(verifyinfo.id),
        endPointUrl: "/updateAddressFromTracking",
        timezone_name: browserTimeZone(),
        newLatLng: newLocations,
      }),
    );
    if (!isloading && shipmentStatus === true) {
      setVisible(false);
    }

  }
  const VerifyAddress = () => {
    dispatch(
      verifyAddressThunk({
        id: 0,
        status: true,
        shipmentInfo: {
          shipment_id: Number(newUserData.shipment_id),
          address_book_id: Number(newUserData.address_id)
        },
        endPointUrl: "/verifyAddress",
        timezone_name: browserTimeZone()
      })
    )
    if (!isloading && shipmentStatus === true) {
      setVisible(false);
    }
  }
  return (
    <>
      <style>{`
  .pac-container.pac-logo.hdpi {z-index: 999999 !important;
   }`}
      </style><Dialog className="av_verify" visible={visible} onHide={() => { if (!visible) return; setVisible(false); }}
        style={{ width: '80vw', backgroundColor: 'White' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
        <div className="m-0">
          <div className="modal-dialog modal-xl custome_xl">
            <div className="modal-content">
              <div className="modal-header UpdateVerify_Head">
                <div className="header_container">
                  <div className="h_left">
                    <h3 className="modal-title h__title">
                      <strong>Current Address:</strong>
                      <span className="orchid_className">{Address.shipment_address1} {Address.shipment_address2} {Address.shipment_customer_city} {Address.shipment_state} {Address.shipment_postcode} {Address.shipment_customer_country}
                      </span>
                      <span className="propp" data-bs-custom-className="custom-popover" title="Please contact the concerned person inorder to verify the address again."
                      >
                        <i className="fa-solid fa-info"></i>
                      </span>
                    </h3>
                  </div>
                  <div className="h_right">
                    {verifyinfo.is_verify !== '0' && verifyinfo.length === 0 ?
                      <button type="button" className="btn btn-primary" onClick={VerifyAddress}>
                        Verify Address
                      </button>
                      : <button type="button" className="btn btn-primary">
                        Address VERIFIED
                      </button>}
                    <button type="button" className="btn-close UpdateVerify_close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setVisible(false)}><i className="fa-solid fa-circle-xmark"></i></button>
                  </div>
                </div>
              </div>
              <div className="modal-body UpdateVerify_body">
                <div className="UpdateVerify_Container space_remover">
                  <div className="left_Section">
                    <form>
                      <div className="formGroups">
                        <div className="topGroups">
                          <div className="update_hedline">
                            <h3>Update Contact Information</h3>
                          </div>
                          <div className="upLeft">
                            <CustomerNameComponent />
                            <CustomerPhoneComponent />
                            <CustomerEmailComponent />
                          </div>

                          <div className="UpdateVerify_submit">
                            <button type="button" onClick={contactAddress}>
                              Update</button>
                          </div>
                        </div>

                        <div className="bottomGroups">
                          <div className="update_hedline">
                            <h3>Update Address</h3>
                          </div>
                          <div className="search_place">
                            <Autocomplete
                              options={{
                                types: ["(regions)"],
                                // componentRestrictions: { country: countryCode }
                              }
                              }
                              onPlaceSelected={(place: any) => {
                                //loop
                                let info=processAddress(place);
                                let country=countrylist.find(c=>c.alpha2_code==info.countrycode);
                                info.countrycode=country?.alpha3_code??info.countrycode;
                                dispatch(UpdateAddressfromAuto(info));
                              }} />
                          </div>
                          <div className="upRight">
                            <ShipmentAddress1Component />
                            <ShipmentAddress2Component />
                            <ShipmentCityComponent />
                            <ShipmentStateComponents />
                            <ShipmentCountryComponent />
                            <ShipmentPostcodeComponent />
                          </div>
                          <div className="UpdateVerify_submit">
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={UserTrackingAddress}>
                              Update & Verify Address</button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <MapComponent />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dialog></>
  )
}
const processAddress=(place:any):{
  address_line_one:string,
  address_line_two:string,
  city:string,
  state:string,
  postcode:string,
  country:string,
  countrycode:string,
  lat:string,
  long:string
}=>{

  let info={
    address_line_one:'',
    address_line_two:'',
    city:'',
    state:'',
    postcode:'',
    country:'',
    countrycode:'',
    lat:'',
    long:''
  };

  for (let v of place.address_components) {
    // console.log(place);
    if(v.types[0] === 'route'){
      info.address_line_one=v.long_name;
    }
    for (let v of place.address_components) {
      if(v.types[0] === 'locality'){
        info.address_line_two=v.long_name;
      }
  }
  for (let v of place.address_components) {
    if(v.types[0] === 'administrative_area_level_1'){
      info.state=v.long_name;
    }
}
  for (let v of place.address_components) {
    if(v.types[0] === 'postal_town'){
     info.city = v.long_name;
    }
  }
    for (let v of place.address_components) {
      if(v.types[0] === 'country'){
        info.country = v.long_name;
        info.countrycode = v.short_name;
      }
  }
  for (let v of place.address_components) {
    //console.log(v);
    if(v.types[0] === 'postal_code'){
      info.postcode = v.long_name;
    }
}
      info.lat = place.geometry.location.lat();
      info.long = place.geometry.location.lng();

}
  return info;
}
export default VerifyAddressComponent;